import React, { useState } from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { motion } from 'framer-motion';
import { Check, Gift, Headphones, ChevronDown } from 'lucide-react';
export function OfferBonuses() {
  const [showRitualDetails, setShowRitualDetails] = useState(false);
  const [showTestDetails, setShowTestDetails] = useState(false);
  return <Section id="offer" background="black" className="text-white relative overflow-hidden" data-id="element-122">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#D4AF37] opacity-5 rounded-full blur-[100px] pointer-events-none" data-id="element-123"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-124">
        <div className="text-center mb-16" data-id="element-125">
          <h2 className="text-4xl md:text-6xl font-bold mb-4 text-white" data-id="element-126">
            Mente de Rica
          </h2>
          <p className="text-2xl text-[#D4AF37] font-serif italic" data-id="element-127">
            30 días para pensar como Millonaria
          </p>

          {/* Pricing and Offer Details */}
          <div className="mt-8 mb-4" data-id="element-128">
            <div className="inline-block bg-black rounded-lg px-8 py-4" data-id="element-129">
              <p className="text-5xl md:text-6xl font-bold text-[#D4AF37] mb-2" data-id="element-130">
                $11.97
              </p>
              <p className="text-lg text-white font-medium" data-id="element-131">
                Programa Completo + Bonos Gratis Incluidos
              </p>
            </div>
          </div>

          {/* New Hero Image */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-12 max-w-4xl mx-auto" data-id="element-132">
            <img src="https://cdn.magicpatterns.com/uploads/sJnsGdPKikoDdsNxMfTnQL/device-mockups-menterica-fondonegro.png" alt="Mente de Rica - Dispositivos" className="w-full drop-shadow-2xl" data-id="element-133" />
          </motion.div>
        </div>

        {/* Offer Details - Centered */}
        <div className="max-w-2xl mx-auto mb-16" data-id="element-134">
          <div className="bg-gray-900/50 backdrop-blur-sm p-8 rounded-2xl border border-gray-800" data-id="element-135">
            <h3 className="text-2xl font-bold mb-6" data-id="element-136">Lo que recibes hoy:</h3>
            <ul className="space-y-4 mb-8" data-id="element-137">
              <li className="flex items-start" data-id="element-138">
                <Check className="text-[#D4AF37] mr-3 mt-1 flex-shrink-0" data-id="element-139" />
                <span data-id="element-140">Programa completo de 30 días de reprogramación</span>
              </li>
              <li className="flex items-start" data-id="element-141">
                <Check className="text-[#D4AF37] mr-3 mt-1 flex-shrink-0" data-id="element-142" />
                <span data-id="element-143">Ejercicios diarios de mentalidad financiera</span>
              </li>
              <li className="flex items-start" data-id="element-144">
                <Check className="text-[#D4AF37] mr-3 mt-1 flex-shrink-0" data-id="element-145" />
                <span data-id="element-146">Acceso de por vida al contenido</span>
              </li>
            </ul>

            {/* Bonuses */}
            <div className="space-y-4 mb-8" data-id="element-147">
              <div className="bg-[#D4AF37]/10 p-4 rounded-lg border border-[#D4AF37]/30 flex items-center" data-id="element-148">
                <Headphones className="text-[#D4AF37] w-8 h-8 mr-4 flex-shrink-0" data-id="element-149" />
                <div data-id="element-150">
                  <span className="text-xs uppercase tracking-wider text-[#D4AF37] font-bold" data-id="element-151">
                    Bono Exclusivo
                  </span>
                  <p className="font-medium" data-id="element-152">
                    Ritual Audio "Mente de Rica" (7 Minutos)
                  </p>
                </div>
              </div>

              <div className="bg-[#D4AF37]/10 p-4 rounded-lg border border-[#D4AF37]/30 flex items-center" data-id="element-153">
                <Gift className="text-[#D4AF37] w-8 h-8 mr-4 flex-shrink-0" data-id="element-154" />
                <div data-id="element-155">
                  <span className="text-xs uppercase tracking-wider text-[#D4AF37] font-bold" data-id="element-156">
                    Bono Exclusivo
                  </span>
                  <p className="font-medium" data-id="element-157">
                    Test de Identidad Financiera Latina
                  </p>
                </div>
              </div>
            </div>

            <div className="text-center" data-id="element-158">
              <Button variant="primary" size="lg" fullWidth withArrow className="text-lg" href="https://impactlifemethod.com/cart/48458233610464:1" trackAddToCart={true} data-id="element-159">
                Comprar ahora
              </Button>
              <p className="mt-4 text-sm text-gray-400" data-id="element-160">
                Acceso digital inmediato • Compra 100% segura
              </p>
            </div>
          </div>
        </div>

        {/* Bonus Visuals */}
        <div className="grid md:grid-cols-2 gap-8 mt-12" data-id="element-161">
          <div className="bg-black p-6 rounded-xl border border-[#D4AF37] flex flex-col items-center text-center" data-id="element-162">
            <img src="https://cdn.magicpatterns.com/uploads/qS2gBGA3CqUvfKUaNGNjyx/ritual-audio-7min.png" alt="Audio Ritual" className="h-48 object-contain mb-4" data-id="element-163" />
            <h4 className="text-xl font-bold text-[#D4AF37] mb-2" data-id="element-164">
              Ritual Audio (7 Min)
            </h4>
            <p className="text-gray-400 text-sm mb-3" data-id="element-165">
              Reprograma tu mente subconsciente diariamente con este audio
              exclusivo.
            </p>

            {/* Read More Toggle */}
            <button onClick={() => setShowRitualDetails(!showRitualDetails)} className="text-[#D4AF37] text-sm font-medium hover:text-[#B4941F] transition-colors flex items-center gap-1" data-id="element-166">
              Leer más
              <ChevronDown className={`w-4 h-4 transition-transform ${showRitualDetails ? 'rotate-180' : ''}`} data-id="element-167" />
            </button>

            {/* Expandable Content */}
            <motion.div initial={false} animate={{
            height: showRitualDetails ? 'auto' : 0,
            opacity: showRitualDetails ? 1 : 0
          }} transition={{
            duration: 0.3
          }} className="overflow-hidden" data-id="element-168">
              <div className="mt-4 pt-4 border-t border-[#D4AF37]/30 text-left space-y-3" data-id="element-169">
                <p className="text-gray-300 text-sm leading-relaxed" data-id="element-170">
                  Un ritual guiado de solo 7 minutos al día, diseñado para
                  ayudarte a calmar tu sistema nervioso, reafirmar tu identidad
                  de abundancia y reprogramar tu relación con el dinero sin
                  esfuerzo mental.
                </p>
                <p className="text-gray-300 text-sm leading-relaxed" data-id="element-171">
                  Este audio te acompaña paso a paso con una voz cálida y
                  segura, ideal para usar por la mañana o antes de dormir,
                  incluso en días de cansancio o saturación. No necesitas
                  concentrarte ni "pensar positivo": solo escuchar, respirar y
                  permitir que tu mente haga el trabajo.
                </p>
                <p className="text-gray-300 text-sm leading-relaxed" data-id="element-172">
                  El complemento perfecto para integrar Mente de Rica en tu día
                  a día y sostener cambios reales desde la calma, no desde la
                  presión.
                </p>
              </div>
            </motion.div>
          </div>

          <div className="bg-black p-6 rounded-xl border border-[#D4AF37] flex flex-col items-center text-center" data-id="element-173">
            <img src="https://cdn.magicpatterns.com/uploads/h1CB1KFhUUvxs76q89v3jr/device-mokusps-test-azulmarino.png" alt="Test Identidad" className="h-48 object-contain mb-4" data-id="element-174" />
            <h4 className="text-xl font-bold text-[#D4AF37] mb-2" data-id="element-175">
              Test de Identidad
            </h4>
            <p className="text-gray-400 text-sm mb-3" data-id="element-176">
              Descubre desde dónde estás operando con el dinero actualmente.
            </p>

            {/* Read More Toggle */}
            <button onClick={() => setShowTestDetails(!showTestDetails)} className="text-[#D4AF37] text-sm font-medium hover:text-[#B4941F] transition-colors flex items-center gap-1" data-id="element-177">
              Leer más
              <ChevronDown className={`w-4 h-4 transition-transform ${showTestDetails ? 'rotate-180' : ''}`} data-id="element-178" />
            </button>

            {/* Expandable Content */}
            <motion.div initial={false} animate={{
            height: showTestDetails ? 'auto' : 0,
            opacity: showTestDetails ? 1 : 0
          }} transition={{
            duration: 0.3
          }} className="overflow-hidden" data-id="element-179">
              <div className="mt-4 pt-4 border-t border-[#D4AF37]/30 text-left space-y-3" data-id="element-180">
                <p className="text-gray-300 text-sm leading-relaxed" data-id="element-181">
                  Antes de cambiar tu relación con el dinero, necesitas saber
                  desde dónde estás operando hoy.
                </p>
                <p className="text-gray-300 text-sm leading-relaxed" data-id="element-182">
                  Este test breve de 25 preguntas revela si tu mentalidad
                  financiera está funcionando desde supervivencia, sacrificio,
                  culpa o expansión consciente, y te muestra qué emoción está
                  guiando tus decisiones.
                </p>
                <p className="text-gray-300 text-sm leading-relaxed" data-id="element-183">
                  Obtendrás tu resultado, una interpretación emocional clara y
                  una recomendación personalizada del enfoque de Mente de Rica
                  que necesitas ahora mismo, para avanzar sin forzarte ni
                  sabotearte.
                </p>
                <p className="text-gray-300 text-sm leading-relaxed" data-id="element-184">
                  Un diagnóstico poderoso para dejar de adivinar… y empezar a
                  trabajar con tu verdadera identidad financiera.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </Section>;
}